import {forEach} from 'lodash'
import {getManifestItemForDocItem} from 'powtoon-document/manifest'
import {isTextItem} from 'powtoon-document'

import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.05.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema, {strict: false})
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {strictMode, ignoreManifest, isValidTime, getMinTimeStep})

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content) {
  forEach(content.powtoon.slides, slide => {
    forEach(slide.tracks, track => {
      const sprite = track.sprites[0]

      if (!isTextItem(sprite)) {
        return
      }

      if (!!sprite.fontFamily) {
        sprite.contentItemId = sprite.fontFamily
        const manifestItem = getManifestItemForDocItem(content.powtoon.manifest, sprite)
        sprite.fontName = manifestItem ? manifestItem.name : sprite.fontFamily

        delete sprite.fontFamily
      }
    })
  })
}
